
export enum ModulesEnum {
    PPS = 'PPS',
    TMS = 'TMS',
    PTS = 'PTS'
}